<template>
    <modal
        id="cookies-modal"
        size="lg"
        title="Termos de Gerenciamento de Cookies"
        okTitle="Salvar"
        :noCloseOnEsc="true"
        :noCloseOnBackdrop="true"
        :isOpen="isOpen"
        :isModalRoute="false"
        :scrollable="true"
        :okOnly="true"
        buttonSize="md"
        @hideHandler="handleHideEvent"
    >
        <div class="container">
            <p>
                Cookies são arquivos temporários que armazenam informações
                básicas do usuário ao navegar pelos sites, aplicativos e sistema
                CoBlue.
            </p>

            <p>
                O objetivo do uso de cookies nos sistemas CoBlue, é de fornecer
                um serviço mais personalizado e eficaz baseado nas escolhas dos
                usuários (análise de tendências).
            </p>

            <p>
                Sendo assim, a CoBlue poderá coletar informações básicas de
                navegação (para melhorar a experiência do usuário) sempre que a
                função de cookies estiver ativa.
            </p>

            <p>
                Como a maioria das empresas de tecnologia, coletamos
                automaticamente esses dados e os armazenamos em arquivos de
                registro sempre que você visita nosso site ou acesse sua conta
                em nosso sistema. Quais os tipos de Cookies que a Coblue pode
                utilizar?
            </p>
            <div class="switch-paragraph">
                <b-row class="paragraph-title">
                    <b-col cols="8">
                        <h5>Cookies Persistentes</h5>
                    </b-col>
                    <b-col cols="4" class="floating-item">
                        <label>
                            Sempre ativo
                        </label>
                    </b-col>
                </b-row>
                <p>
                    Estes cookies são necessários para o correto funcionamento
                    do nosso site. Geralmente, são configurados para atender
                    solicitações de serviços como: preenchimento de formulários,
                    preferências de privacidade e início de sessão. Você pode
                    configurar seu navegador para bloquear e alertar sobre o uso
                    desse tipo de cookie, contudo o site pode ter problemas no
                    seu funcionamento.
                </p>
            </div>
            <div class="switch-paragraph">
                <b-row class="paragraph-title">
                    <b-col cols="8">
                        <h5>Cookies de Sessão</h5>
                    </b-col>
                    <b-col cols="4" class="floating-item">
                        <label>
                            Sempre ativo
                        </label>
                    </b-col>
                </b-row>
                <p>
                    Estes cookies estão associados com a memória de curto prazo.
                    O objetivo no uso desse cookie é de reconhecer o usuário a
                    cada sessão iniciada. Os cookies de sessão são expirados
                    assim que o navegador é fechado.
                </p>
            </div>

            <div class="switch-paragraph">
                <b-row class="paragraph-title">
                    <b-col cols="8">
                        <h5>Cookies de terceiros</h5>
                    </b-col>
                    <b-col cols="4" class="floating-item">
                        <b-form-checkbox
                            variant="primary"
                            v-model="optionalCookies"
                            :checked="true"
                            switch
                        ></b-form-checkbox>
                    </b-col>
                </b-row>
                <p>
                    O uso deste tipo de cookie é voltado para publicidade de
                    nossos parceiros. Podem ser usados por outras empresas para
                    criar um perfil de interesse de usuários e mostrar anúncios
                    assertivos em outros sites. Eles não armazenam informações
                    pessoais. A desativação não compromete o desempenho do site.
                </p>
            </div>
            <!-- eslint-disable no-irregular-whitespace -->
            <p>
                Você pode optar por limitar, recusar ou desabilitar os Cookies
                através das configurações de Gerenciamento de cookies. Contudo,
                ao fazer isso, algumas áreas do nosso site podem não funcionar
                corretamente, o que poderá impedir que você se beneficie de
                alguns de nossos recursos. Esta Política de Cookies não cobre o
                uso de Cookies por terceiros, e não somos responsáveis ​​por
                suas políticas e práticas de privacidade. Tenha em atenção que
                os Cookies colocados por terceiros podem eventualmente continuar
                a monitorizar as suas atividades online mesmo depois de ter
                saído dos nossos Serviços. A CoBlue se reserva o direito de
                atualizar a presente Política de Cookies a qualquer momento,
                mantendo-a sempre disponível no site. Em caso de atualização, o
                usuário será informado sobre a alteração e poderá optar pela
                desativação de cookies da CoBlue.
            </p>
        </div>
    </modal>
</template>

<script>
import Modal from '@/views/components/modal'

export default {
    name: 'CookiesModal',
    components: {
        Modal,
    },
    data() {
        return {
            isOpen: true,
            optionalCookies: true,
        }
    },
    methods: {
        handleHideEvent() {
            this.isOpen = false
            this.$emit('modalClosed', { optionalCookies: this.optionalCookies })
        },
    },
}
</script>

<style lang="sass">
$blue: #5d9cec

.modal-title
    color: $blue
    font-size: 23px

.floating-item
    font-weight: bold
    text-align: right
.switch-paragraph
    text-align: justify
</style>
